// PDF埋め込み用に画像（data URL）を縮小する。撮影時の圧縮は解析API向けに精度優先
// モードで長辺2048pxまで作られるが、PDF上ではもっと小さい枠にしか描画されない。
// そのまま渡すと生成のたびにフル解像度でデコードすることになり、iPhone SEでは
// 生成時間の大半を占める。失敗しても元画像で続行し、PDF生成自体は止めない
// （姉妹アプリfood-label-assistで見つかった不具合と同じ対策。PR#138参照）
export function downscaleForPdf(dataUrl, maxSize = 300) {
  return new Promise((resolve) => {
    if (typeof dataUrl !== 'string' || !dataUrl.startsWith('data:')) { resolve(dataUrl); return; }
    const img = new Image();
    img.onerror = () => resolve(dataUrl);
    img.onload = () => {
      const longest = Math.max(img.width, img.height);
      if (longest <= maxSize) { resolve(dataUrl); return; }
      const ratio = maxSize / longest;
      const canvas = document.createElement('canvas');
      canvas.width = Math.round(img.width * ratio);
      canvas.height = Math.round(img.height * ratio);
      canvas.getContext('2d').drawImage(img, 0, 0, canvas.width, canvas.height);
      try { resolve(canvas.toDataURL('image/jpeg', 0.8)); }
      catch (_) { resolve(dataUrl); }
    };
    img.src = dataUrl;
  });
}
